import * as React from "react"
import { Link } from "react-router-dom"
import { CardModal, CardModalNotOkButton, CardModalType } from "../../modal"
import { Service, LocalAuthority, ServiceGroup, BergerLevrault, ElementAnalytiqueBergerLevrault, User } from "../../../model"
import { getFullName } from "../../../domain/sfp/user-domain"
import BoundedInput from "../../InputForm/BoundedForm"

export default class DetailServiceModalComponent
extends React.Component<DetailServiceModalComponentProps> {

	private labelOption: string = "Associer un service"
	render() {
		const bergerLevrault = this.props.bergerLevrault
		const groups = this.props.groups
		const approaches:any = this.props.localAuthority.approaches
		const selectedServiceBL = this.props.selectedServiceBL
		const service = this.props.service
		const servicesBL = this.props.servicesBL
		const label = service ? service.label : ""
		const title = service
		? `Modifier le service ${label ? label : ''}`
		: "Ajouter un service"

		let selected = service && service.approaches.length > 0 && service.approaches[0].name 
		let approachesFinal = selected ? approaches.filter(r=>r.name !== selected): approaches
		
		return <CardModal active
		loading={this.props.loadingService || this.props.submitting}
		title={title}
		type={CardModalType.ValidCancel}
		onClickCloseButton={this.props.onClickCloseButton}
		onClickFooterButton={this.props.onClickFooterButton}
		onSubmit={this.props.onSubmit}>
			{/* Champ libellé */}
			<div className="field">
				<label className="label" htmlFor={Ids.Label}>Libellé</label>
				<div className="control">
					<BoundedInput
					className="input"
					min="0"
					max="30"
					recommendedMax="30"
					value={service ? service.label : null}
					// disabled={this.props.submitting}
					onChange    = {()=>{}}
					id={Ids.Label}
					name={Names.Label}
					placeholder="Sport"
					required
					type="text" />
				</div>
			</div>

			{/* Champ description */}
			<div className="field">
				<label className="label" htmlFor={Ids.Description}>Description</label>
				<div className="control">
					<input
					className="input"
					defaultValue={service ? service.description : null}
					disabled={this.props.submitting}
					id={Ids.Description}
					name={Names.Description}
					placeholder="Service des sports"
					type="text" />
				</div>
			</div>

			{/* Champ code */}
			{(!bergerLevrault || (bergerLevrault && !bergerLevrault.enabled)) &&
				<div className="field">
					<label className="label" htmlFor={Ids.Code}>Code d'interfaçage</label>
					<div className="control">
						<input
						className="input"
						defaultValue={service ? service.code : null}
						disabled={this.props.submitting}
						id={Ids.Code}
						name={Names.Code}
						placeholder="SPORT"
						type="text" />
					</div>
				</div>
			}

			{/* Champ connecteur */}
			{bergerLevrault && bergerLevrault.enabled &&
			<div className="field">
				<label className="label" htmlFor={Ids.BergerLevrault}>Services Berger Levrault</label>
					<div className="select is-fullwidth is-narrow">
						<select name={Names.Code}
						className={this.props.loadingServicesBL ? "is-loading" : ""}
						disabled={this.props.loadingServicesBL}
						onChange={this.props.onChangeServiceBL}
						value={selectedServiceBL}
						>
							<option>Associer un service</option>
							{servicesBL && servicesBL.length
								? servicesBL.map((service, i) => {
									return <option key={i} value={service.codeElement}>{service.codeElement + ' - ' + service.libelleElement}</option>
									})
								: null}
						</select>
					</div>
			</div>
			}

			{/* Champ agents */}
			{service &&
			<div className="field">
				<label className="label">Agents</label>
				<div className="control">
					<table className="table is-fullwidth is-narrow">
						<thead>
							<tr>
								<th>Prénom</th>
								<th>Nom</th>
								<th>Adresse e-mail</th>
							</tr>
						</thead>
						<tbody>
							{this.props.loadingAgents
							? <tr><td colSpan={3}>Chargement des agents...</td></tr>
							: this.props.agents && this.props.agents.length
								? this.props.agents.map((agent, i) => {
									const fullName = getFullName(agent)
									return <tr key={i}>
										<td>
											<span>{agent.firstName}</span>
											{/* <Link title={`Accéder à la page de ${fullName}`}
											to={`/${this.props.localAuthority.slug}/utilisateurs/${agent.id}`}>
												{agent.firstName}
											</Link> */}
										</td>
										<td>
											<span>{agent.lastName}</span>
											{/* <Link title={`Accéder à la page de ${fullName}`}
											to={`/${this.props.localAuthority.slug}/utilisateurs/${agent.id}`}>
												{agent.lastName}
											</Link> */}
										</td>
										<td>
											<a href={`mailto:${agent.email}`}
											title={`Ecrire un e-mail à ${fullName}`}>
												{agent.email}
											</a>
										</td>
									</tr>})
								: <tr><td colSpan={3}>Aucun agent n’est lié à ce service</td></tr>}
						</tbody>
					</table>
				</div>
			</div>}

			{/* Champ groupe service */}

			<div className="field">
				<label className="label">Groupes</label>
				<div className="select is-fullwidth is-narrow">
					<select name={Names.Group} defaultValue={service && service.serviceGroup ? service.serviceGroup.toString() : ""} disabled={groups && groups.length && !this.props.loadingService && !this.props.submitting ? false : true}>
						<option>Non défini</option>
						{groups && groups.length
							? groups.map((grp, i) => {
								return <option key={i} value={grp.id.toString()}>{grp.label}</option>
								})
							: null}
					</select>
				</div>
			</div>

			<div className="field">
				<label className="label">Associer le service politique</label>
				<div className="select is-fullwidth is-narrow">
					<select name={Names.Approaches} defaultValue={selected} disabled={approaches && approaches.length && !this.props.loadingService && !this.props.submitting ? false : true} >
						<option>Non défini</option>
						{selected &&<option>{selected}</option>}
						{approachesFinal && approachesFinal.length
							? approachesFinal.map((pol, i) => {
								return <option key={i} value={pol.id.toString()} >{pol.name}</option>
								})
							: null}
					</select>
				</div>
			</div>
		</CardModal>
	}



}

export enum Names {
	BergerLevrault = "berger-levrault",
	Code = "code",
	Description = "description",
	Label = "label",
	Group = "group",
	Approaches ="approaches"
}


export interface DetailServiceModalComponentProps {
	agents: User[]
	bergerLevrault: BergerLevrault
	loadingAgents: boolean
	loadingServicesBL: boolean
	loadingService: boolean
	localAuthority: LocalAuthority
	groups: ServiceGroup[]
	Politique:any
	selectedServiceBL: string
	service?: Service
	servicesBL: ElementAnalytiqueBergerLevrault[]
	submitting: boolean
	onChangeServiceBL(e: React.SyntheticEvent<Element>): void
	onClickCloseButton(e: React.SyntheticEvent<Element>): void
	onClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void
	onSubmit(e: React.SyntheticEvent<Element>): void
}

enum Ids {
	BergerLevrault = "detail-service-berger-levrault",
	Code = "detail-service-code",
	Description = "detail-service-description",
	Label = "detail-service-label",
	Services = "detail-service-services-berger-levrault"
}



// WEBPACK FOOTER //
// ./src/component/services/detail-service-modal/detail-service-modal-component.tsx